// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3PmkM","outlined":"styles_outlined__3YWze","transparent":"styles_transparent__3hVoY"};